// @flow
/**
 * Created by Mike Chung on 2/27/18.
 */
import React from "react";
import * as _ from "lodash";

type TableCellProps = {
    className?: string,
    colSpan?: number
}

export default function TableCell(props: TableCellProps) {
    const {className, ...rest} = props;
    let clazz = `divTableCell ${_.defaultTo(className, "")}`;
    return (
        <div className={clazz} {...rest} />
    );
}


// WEBPACK FOOTER //
// ./src/components/util/tables/TableCell.js